// === at the top ===
const getCurrencySymbol = () => $('#currency_code').val() || '';
const bundleSelections = new Map();
let bundleCount = 0; // always reflects the total quantity selected

function updateBundleCount() {
    let total = 0;
    for (const q of bundleSelections.values()) total += Number(q) || 0;
    bundleCount = total;

    console.log("bundleCount updated:", bundleCount);

    // progress meter: 2 → 33.33%, 3–5 → 66.66%, 6+ → 100%, else 0
    const $meter = $('.select_variants_meter span');
    if (bundleCount >= 6) {
        $meter.css('width', '100%');
    } else if (bundleCount >= 3) {
        $meter.css('width', '66.66%');
    } else if (bundleCount === 2) {
        $meter.css('width', '33.33%');
    } else {
        $meter.css('width', '0');
    }

    // helper: stagger add, instant remove
    function staggerSelected($el, condition, delay = 80) {
        if (condition) {
        if (!$el.hasClass('selected')) {
            setTimeout(() => $el.addClass('selected'), delay);
        }
        } else {
            $el.removeClass('selected'); // immediate on decrease
        }
    }

    // option 1 is immediate (no stagger)
    $('#bundle_option_1').toggleClass('selected', bundleCount >= 1);

    // option 2: ≥2, option 3: ≥3, option 4: ≥6 (staggered adds)
    staggerSelected($('#bundle_option_2'), bundleCount >= 2);
    staggerSelected($('#bundle_option_3'), bundleCount >= 3);
    staggerSelected($('#bundle_option_4'), bundleCount >= 6);

    if (bundleCount == 1) {
      setTimeout(function() {
        $('#bundle_option_1').addClass('active');
      }, 80);
    } else {
      $('#bundle_option_1').removeClass('active');
    }

    if (bundleCount == 2) {
      setTimeout(function() {
        $('#bundle_option_2').addClass('active');
      }, 80);
    } else {
      $('#bundle_option_2').removeClass('active');
    }

    if (bundleCount >= 3 && bundleCount < 6) {
      setTimeout(function() {
        $('#bundle_option_3').addClass('active');
      }, 80);
    } else {
      $('#bundle_option_3').removeClass('active');
    }

    if (bundleCount >= 6) {
      setTimeout(function() {
        $('#bundle_option_4').addClass('active');
      }, 80);
    } else {
      $('#bundle_option_4').removeClass('active');
    }

    // enable/disable state
    $('#variant_bundle_add_to_cart').toggleClass('active', bundleCount >= 1);
    
    // total + currency
    let totalCents = 0;
    for (const [id, qty] of bundleSelections) {
      const priceCents = parseInt($(`.product-variant[data-id="${id}"]`).attr('data-price'), 10) || 0;
      totalCents += priceCents * (Number(qty) || 0);
    }
    const symbol = $('#currency_code').val() || '';

    const fmt = (c) => (c % 100 === 0 ? (c / 100).toString() : (c / 100).toFixed(2));

    let rate = 0;
    if (bundleCount >= 6) rate = 30;
    else if (bundleCount >= 3) rate = 25;
    else if (bundleCount === 2) rate = 20;

    const discountedCents = Math.round(totalCents * (100 - rate) / 100);
    const amount       = fmt(totalCents);
    const discounted   = fmt(discountedCents);
    const savingsCents = totalCents - discountedCents;
    const savings      = fmt(savingsCents);

    // button label – always show discounted price once 1 item is chosen
    let labelHtml;
    if (bundleCount >= 1) {
      labelHtml = `Add to Cart - ${symbol}${discounted}`;
      $('.fixed_form_unavailable span').html(labelHtml);
      $('.fixed_form_unavailable').removeClass('test1');
      $('.fixed_form_unavailable').addClass('test2');
    } else {
      labelHtml = 'Add at least 1 mirror';
      $('.fixed_form_unavailable span').html('Choose Mirrors');
      $('.fixed_form_unavailable').addClass('test1');
      $('.fixed_form_unavailable').removeClass('test2');
    }
    $('#variant_bundle_add_to_cart').html(labelHtml);

    // savings line (optional)
    if (bundleCount >= 1 && savingsCents > 0) {
      $('#you_are_saving').html(`${symbol}${savings}`).show();
    } else {
      $('#you_are_saving').html(`${symbol}0`).show();
    }

}


// === handlers ===

// Click: per-variant "Add" button
$(document).on('click', '.product-variant .add.step', function (e) {
  e.preventDefault();

  const $variant = $(this).closest('.product-variant');
  const variantId = $variant.data('id');

  $variant.find('.quantity-input').val(1);
  $variant.find('.quantity-selector').show();
  $(this).hide();

  bundleSelections.set(String(variantId), 1);
  updateBundleCount();
});

// Click: quantity increase/decrease
$(document).on('click', '.product-variant .quantity-btn', function (e) {
  e.preventDefault();

  const $variant = $(this).closest('.product-variant');
  const variantId = String($variant.data('id'));
  const $input = $variant.find('.quantity-input');
  let qty = parseInt($input.val(), 10) || 1;

  if ($(this).hasClass('increase')) {
    qty += 1;
  } else if ($(this).hasClass('decrease')) {
    qty -= 1;
  }

  if (qty <= 0) {
    bundleSelections.delete(variantId);
    $variant.find('.quantity-selector').hide();
    $variant.find('.add.step').show();
    $input.val(1);
  } else {
    $input.val(qty);
    bundleSelections.set(variantId, qty);
  }

  updateBundleCount();
});

// Optional: keep Map in sync if user types
$(document).on('change', '.product-variant .quantity-input', function () {
  const $variant = $(this).closest('.product-variant');
  const variantId = String($variant.data('id'));
  let qty = parseInt($(this).val(), 10) || 1;

  if (qty <= 0) {
    bundleSelections.delete(variantId);
    $variant.find('.quantity-selector').hide();
    $variant.find('.add.step').show();
    $(this).val(1);
  } else {
    bundleSelections.set(variantId, qty);
  }

  updateBundleCount();
});

// Click: "Add to Cart" (batch add all selected variants)
$(document).on('click', '#variant_bundle_add_to_cart', function (e) {
  e.preventDefault();

  const items = Array.from(bundleSelections.entries()).map(([id, quantity]) => {
    const item = {
      id: Number(id),
      quantity: Number(quantity)
    };

    const $variant   = $(`.product-variant[data-id="${id}"]`);
    const inventory  = parseInt($variant.attr('data-inventory'), 10);
    const preorderText = $variant.attr('data-preorder-text'); // ← dynamic value

    if (inventory <= 0 && preorderText) {
      item.properties = {
        'Pre-order': preorderText
      };
    }

    return item;
  });

  if (!items.length) return;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items }),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function () {
      document.dispatchEvent(new CustomEvent('cart:batch-added', {
        detail: { items, bundleCount }
      }));
    },
    error: function (xhr) {
      console.error('Bundle add failed:', xhr?.responseText || xhr);
    }
  });
});

// Click: "Add to Cart" (batch add all selected variants)
$(document).on('click', '.test2', function (e) {
  e.preventDefault();

  const items = Array.from(bundleSelections.entries()).map(([id, quantity]) => {
    const item = {
      id: Number(id),
      quantity: Number(quantity)
    };

    const $variant   = $(`.product-variant[data-id="${id}"]`);
    const inventory  = parseInt($variant.attr('data-inventory'), 10);
    const preorderText = $variant.attr('data-preorder-text'); // ← dynamic value

    if (inventory <= 0 && preorderText) {
      item.properties = {
        'Pre-order': preorderText
      };
    }

    return item;
  });

  if (!items.length) return;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items }),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function () {
      document.dispatchEvent(new CustomEvent('cart:batch-added', {
        detail: { items, bundleCount }
      }));
    },
    error: function (xhr) {
      console.error('Bundle add failed:', xhr?.responseText || xhr);
    }
  });
});